const etapaDefinirEncaminhamento = {
  id: 'definir-encaminhamento',
  label: 'Definir encaminhamento',
  statuses: ['IDENTIFICADO'],
  tarefa: 'DEFINIR_ENCAMINHAMENTO'
};

const etapasAposCorrecao = [
  { id: 'validar-correcao', label: 'Validar correção', statuses: ['AGUARDANDO_VALIDACAO'], tarefa: 'VALIDAR_CORRECAO' },
  { id: 'encerrar-erro', label: 'Encerrar erro', statuses: [], tarefa: 'ENCERRAR_ERRO' },
  { id: 'encerrado', label: 'Encerrado', statuses: ['ENCERRADO'], tarefa: null }
];

const etapasAposCorrigirPrimeiro = [
  { ...etapasAposCorrecao[1], statuses: ['EM_CORRECAO'], tarefa: 'ENCERRAR_ERRO' },
  etapasAposCorrecao[2]
];

export const fluxosTratamentoErro = [
  {
    id: 'CORRIGIR_PRIMEIRO',
    label: 'Corrigir primeiro',
    descricao:
      'Este caminho é utilizado quando o erro exigir uma ação imediata, antes de uma análise detalhada, com o objetivo de corrigir ou conter o problema na base atual.',
    steps: [
      etapaDefinirEncaminhamento,
      { id: 'corrigir-primeiro', label: 'Escolher fluxo', statuses: ['EM_CORRECAO', 'REABERTO'], tarefa: null },
      ...etapasAposCorrigirPrimeiro
    ]
  },
  {
    id: 'ANALISAR_PRIMEIRO',
    label: 'Analisar primeiro',
    descricao: 'Este caminho é utilizado quando o erro exigir investigação antes da definição da correção.',
    steps: [
      etapaDefinirEncaminhamento,
      { id: 'analisar-erro', label: 'Analisar erro', statuses: ['EM_DIAGNOSTICO'], tarefa: 'ANALISAR_ERRO' },
      { id: 'encerrar-erro', label: 'Encerrar erro', statuses: ['EM_DIAGNOSTICO'], tarefa: 'ENCERRAR_ERRO' },
      etapasAposCorrecao[2]
    ]
  },
  {
    id: 'NAO_APLICAVEL',
    label: 'Não aplicável',
    descricao:
      'Este caminho é utilizado quando o erro não exigir correção, estiver tecnicamente justificado ou não se aplicar ao contexto da base analisada.',
    steps: [
      etapaDefinirEncaminhamento,
      { id: 'nao-aplicavel', label: 'Justificar erro', statuses: ['NAO_APLICAVEL'], tarefa: 'JUSTIFICAR_ERRO' },
      etapasAposCorrecao[1],
      etapasAposCorrecao[2]
    ]
  }
];

export function obterFluxoAtual(erro) {
  const encaminhamento = String(erro.encaminhamento_inicial || '').toUpperCase();
  const status = String(erro.status_erro || '').toUpperCase();

  if (status === 'NAO_APLICAVEL') return 'NAO_APLICAVEL';
  if (fluxosTratamentoErro.some((fluxo) => fluxo.id === encaminhamento)) return encaminhamento;
  if (status === 'EM_DIAGNOSTICO') return 'ANALISAR_PRIMEIRO';
  if (status === 'REABERTO') return null;
  if (status === 'EM_CORRECAO') return 'CORRIGIR_PRIMEIRO';

  return null;
}

export function progressoFluxo(erro) {
  const fluxo = fluxosTratamentoErro.find((item) => item.id === obterFluxoAtual(erro));

  if (!fluxo) return 0;

  const indiceEtapa = indiceEtapaAtual(fluxo, erro);

  if (indiceEtapa < 0) return 0;

  return Math.round((indiceEtapa / (fluxo.steps.length - 1)) * 100);
}

function indiceEtapaAtual(fluxo, erro) {
  if (String(erro.status_erro || '').toUpperCase() === 'ENCERRADO') {
    return fluxo.steps.length - 1;
  }

  if (erro.pode_executar_corrigir_primeiro === true) {
    return fluxo.steps.findIndex((etapa) => etapa.id === 'corrigir-primeiro');
  }

  const tarefa = Array.isArray(erro.tarefas) && erro.tarefas.length ? erro.tarefas[0] : null;
  const tipoTarefa = String(tarefa?.tipo_tarefa || '').toUpperCase();
  const indiceTarefa = fluxo.steps.findIndex((etapa) => etapa.tarefa === tipoTarefa);

  return indiceTarefa >= 0 ? indiceTarefa : 0;
}
